<template>
  <div id="course-class" :class="isIndex?'paddingBottom':''">
    <top-activity v-if="activityShow"></top-activity>
    <Header />
    <content class="content">
      <router-view />
    </content>
    <Footer />
  </div>
</template>
<script>
import("@/assets/reset.min.css");
import("@/../public/zhugeIO.js");
import topActivity from "@/components/indexComponents/top-activity";
import Header from "@/components/indexComponents/header";
import Footer from "@/components/indexComponents/footer";
import { wxShare, shareInfo } from "@/../public/public";
import { axios } from "@/../api/init";
export default {
  name: "course-class",
  components: { topActivity,Header,Footer },
  data(){
    return{
      isIndex: false,
      activityShow: false
    }
  },
  methods:{
    // 微信分享
    weixinShare(title, description, imgUrl = '') {
      imgUrl = imgUrl || "https://file.boxuegu.com/img/interactive_classroom/logo/logo.png"
      let shareUrl = window.location.href
      wxShare(shareUrl)
      let obj = {
        title: title, // 分享标题
        desc: description, // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        fail: function (res) {
          // alert(JSON.stringify(res))
        }
      }
      shareInfo(obj)
    },
  },
  mounted(){
  },
  watch:{
    $route(res){
      this.weixinShare('回车课堂','互动学习还免费，推荐给你，一起涨知识')
      let routerArr = ['course','detailsPage','index','sceneDetails','scene','about','multiplex','search']
      if(routerArr.indexOf(res.name) === -1){
        this.isIndex = true
      }else{
        this.isIndex = false
      }
      this.activityShow = false
      if (res.path === '/') {
        this.activityShow = true
      }
    }
  }
};
</script>
<style lang="less">
html,body{
  height: 100%;
}
#course-class{
  min-height: 100%;
  background: #f1f7fd;
  position: relative;
  box-sizing: border-box;
}
.paddingBottom{
  padding-bottom: 200px;
}

</style>
<style scoped lang="less">
// 分页
/deep/ .pagination-box{
  text-align: center;
  .el-pager{
    .number{
      width: 40px;
      height: 40px;
      line-height: 40px;
      background-color: #ffffff;
      border-radius: 2px;
      border: solid 1px #dce0e4;
      color: #11223f;
      cursor: pointer;
      font-weight: 400;
      &:hover{
        color: #25c48b !important;
        border: solid 1px #25c48b;
      }
    }
    .more{
      background-color: #ffffff;
      border-radius: 2px;
      border: solid 1px #dce0e4;
      width: 40px;
      height: 40px;
      cursor: pointer;
      &::before{
        line-height: 40px;
      }
      &:hover{
        color: #25c48b !important;
        border: solid 1px #25c48b;
      }
    }
    .active{
      color: #fff !important;
      background-color: #25c48b !important;
      border-radius: 2px;
      border: solid 1px #25c48b;
      &:hover{
        color: #fff !important;
      }
    }
  }
  .btn-prev,.btn-next{
    width: 40px;
    height: 40px;
    background-color: #ffffff !important;
    border-radius: 2px;
    border: solid 1px #dce0e4;
    color: #11223f;
    &:hover{
      border: solid 1px #25c48b;
      color: #25c48b;
    }
    &:disabled{
      color: #ccc;
      border: solid 1px #dce0e4;
    }
  }
  .el-pagination__jump{
    height: 40px;
    line-height: 40px;
  }
  .el-input__inner{
    height: 40px !important;
    background: #fff !important;
    border-color: #fff !important;
    border: solid 1px #dce0e4 !important;
  }
}
@media (max-width: 1199px) {
  /deep/ .container{
    width: 100% !important;
    max-width:100% !important;
  }
}
</style>